function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import cn from 'clsx';
import { bool, node, object, string } from 'prop-types';
import FormInput from '../../atoms/FormInput/index.jsx';
import FormContext from '../../context/FormContext.js';

/**
 * FormInputGroup component.
 */
var _ref = /*#__PURE__*/React.createElement("span", {
  className: "form-input-group__border full-width full-height"
});
const FormInputGroup = ({
  prepend,
  append,
  className,
  defaultValue,
  name,
  formInputRef,
  hasError,
  children,
  ...restProps
}) => {
  const {
    inverted,
    errors,
    mobileSquareBorders,
    defaultValues
  } = useContext(FormContext);
  const isTextArea = restProps.as === 'textarea';
  return /*#__PURE__*/React.createElement("div", {
    className: cn("form-input-group d-flex align-items-stretch", (hasError || errors && name in errors) && 'form-input-group--invalid', className, inverted && 'form-input-group--inverted', mobileSquareBorders && 'form-input-group--mobile-square-borders', isTextArea && 'form-input-group--textarea')
  }, prepend && /*#__PURE__*/React.createElement("div", {
    className: "form-input-group__item d-flex align-items-center text-center" + (typeof prepend !== 'string' ? " form-input-group__item--not-text" : "")
  }, prepend), children ? /*#__PURE__*/React.cloneElement(children, {
    ...restProps,
    borderless: true,
    defaultValue: defaultValue || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[name]) || '',
    name,
    hasError,
    formInputRef
  }) : /*#__PURE__*/React.createElement(FormInput, _extends({}, restProps, {
    borderless: true,
    className: "form-input-group__input form-input-group__item",
    defaultValue: defaultValue || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[name]) || '',
    name: name,
    hasError: hasError,
    ref: formInputRef
  })), _ref, append && /*#__PURE__*/React.createElement("div", {
    className: "form-input-group__item d-flex align-items-center text-center" + (typeof append !== 'string' ? " form-input-group__item--not-text" : "")
  }, append));
};
FormInputGroup.defaultProps = {
  className: null,
  prepend: null,
  append: null,
  defaultValue: null,
  name: null,
  formInputRef: null,
  hasError: false,
  children: null
};
FormInputGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,
  /** Some content to prepend to the input field. */
  prepend: node,
  /** Some content to append to the input field. */
  append: node,
  /** The input field value */
  defaultValue: FormInput.propTypes.defaultValue,
  /** The input name. */
  name: FormInput.propTypes.name,
  /** A ref for the form input. */
  formInputRef: object,
  /** Mark the form group input as invalid. Note that the input will be marked as
    invalid if the errors object in the form context contains a relevant error. */
  hasError: bool,
  /** A node that replaces input */
  children: node
} : {};
export default FormInputGroup;